const Base = () => import("./components/Base.vue")
const HomePage = () => import("./views/HomePage.vue")
const About = () => import("./views/About.vue")
const Bye = () => import("./components/Bye.vue")
const BlogFeed = () => import("./views/BlogFeed.vue")
const BlogArticle = () => import("./views/BlogArticle.vue")
import type { RouteLocationNormalizedGeneric, RouteRecordRaw } from "vue-router"
import AccountRoutes from "../shared-vue/account/AccountRoutes"

function getFirstQueryParam(
  route: RouteLocationNormalizedGeneric,
  paramName: string,
) {
  return Array.isArray(route.query[paramName])
    ? route.query[paramName][0]
    : route.query[paramName]
}

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    component: Base,
    children: [
      { path: "", component: HomePage, name: "ps:home" },
      { path: "about/", component: About, name: "ps:about" },
      {
        path: "blog/feed/",
        component: BlogFeed,
        name: "ps:blog:feed",
        props: (route) => ({
          tag: route.query.tag,
          pageNumber: Number.parseInt(getFirstQueryParam(route, "p") ?? "1"),
        }),
      },
      {
        path: "blog/articles/:slug/",
        component: BlogArticle,
        name: "ps:blog:article",
      },
      { path: "bye/", component: Bye, name: "ps:bye" },
      ...AccountRoutes({ backLocation: { name: "ps:home" } }),
    ],
  },
]

export default routes
